// API Configuration
export const API_CONFIG = {
  // Base URL for API calls
  BASE_URL: process.env.REACT_APP_API_URL || 'https://api.scrapsector.in',
  
  // Default headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    // 'ngrok-skip-browser-warning': 'true', // Skip ngrok browser warning
  },
  
  // Request timeout (in milliseconds)
  TIMEOUT: 30000,
  
  // Retry configuration
  RETRY: {
    maxRetries: 3,
    retryDelay: 1000,
  },
  
  // Cache configuration
  CACHE: {
    // Cache duration in seconds
    defaultCacheTime: 300, // 5 minutes
    // Cache duration for different endpoints
    endpoints: {
      bookings: 60, // 1 minute
      prices: 300, // 5 minutes
      stats: 120, // 2 minutes
      profile: 600, // 10 minutes
    }
  }
};

// Helper function to get API URL
export const getApiUrl = (endpoint = '') => {
  const baseUrl = API_CONFIG.BASE_URL.endsWith('/') 
    ? API_CONFIG.BASE_URL.slice(0, -1) 
    : API_CONFIG.BASE_URL;
  
  const cleanEndpoint = endpoint.startsWith('/') 
    ? endpoint 
    : `/${endpoint}`;
  
  return `${baseUrl}${cleanEndpoint}`;
};

// Helper function to get headers with authentication
export const getHeaders = (token = null) => {
  const headers = { ...API_CONFIG.DEFAULT_HEADERS };
  
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return headers;
};

// Helper function to handle ngrok-specific headers
export const getNgrokHeaders = (additionalHeaders = {}) => {
  return {
    ...API_CONFIG.DEFAULT_HEADERS,
    // 'ngrok-skip-browser-warning': 'true',
    ...additionalHeaders,
  };
};

export default API_CONFIG;
